import React, { Fragment, useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { Box, CardMedia, Chip, Grid, IconButton, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Tooltip, Typography } from '@mui/material';
import Colors from '../../../Assets/Styles/Colors';
import { baseUrl } from '../../../../axios';
import ProposalsServices from '../../../Api/AdBazar/Proposals/ProposalsServices';
import AuthServices from '../../../Api/Auth/AuthServices';
import moment from 'moment';
import { FacebookRounded, LinkedIn, RemoveRedEye, WhatsApp, X, KeyboardArrowLeft } from '@mui/icons-material';

const tableHead = [
  "Job Title",
  "Category",
  "Created At",
  "Valid Till",
  "No. of Proposals",
  "Status",
  "Action"
];
const tableHead1 = ["Applied Date", "Job Title", "Budget", "Duration", "Proposal Status", "Action"];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function ProviderDetails() {
  const [value, setValue] = useState(0);
  const [userProposals, setUserProposals] = useState([]);
  const [userJobs, setUserJobs] = useState([]);
  const { state } = useLocation();
  const navigate = useNavigate();
  console.log(state);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue == 0) {
      getUserJobs();
    } else if (newValue == 1) {
      getUserProposals();
    }
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const getUserProposals = async () => {
    try {
      const result = await ProposalsServices.getAllProposals("", "", "", state?._id, "", "", "", "");
      if (result.responseCode == 200) {
        setUserProposals(result?.data?.proposals)
      }
      console.log("🚀 ~ getUserProposals ~ result:", result)
    } catch (error) {
      console.log(error);
    }
  }

  const getUserJobs = async () => {
    try {
      const result = await AuthServices.getAllJobs("", "", state?._id, "");
      if (result.responseCode == 200) {
        setUserJobs(result?.data?.ads)
      }
      console.log("🚀 ~ getUserProposals ~ result:", result)
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getUserJobs();
  }, []);

  return (
    <Fragment>
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Service Provider Details
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Service Provider Details"]} />
          </Grid>
        </Grid>
        <Box sx={{ mt: "20px" }}>
          <Box
            component={Paper}
            sx={{
              borderRadius: "4px",

              boxShadow: "0px 0px 10px 2px #e3e3e3"
            }}
          >
            <Grid container>
              <Grid item md={3} sx={{ borderRight: "1px solid #E0E0E0" }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    alignItems: "center",
                    p: "20px",
                  }}
                >
                  <Box component={Paper} sx={{
                    borderRadius: "50%", width: "180px",
                    height: "180px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 0px 10px 2px #e3e3e3"
                  }}>
                    <CardMedia
                      component={"img"}
                      src={baseUrl + state?.image}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </Box>
                  <Box>
                    <Typography>
                      {state?.roles}
                    </Typography>
                  </Box>
                </Box>
                <Grid container justifyContent={"center"}>
                  {state?.additional?.facebook && (
                    <Grid item md={2}>
                      <IconButton
                        onClick={() => {
                          const url = state.additional.facebook.startsWith('http')
                            ? state.additional.facebook
                            : `https://${state.additional.facebook}`;
                          window.open(url, '_blank');
                        }}
                      >
                        <FacebookRounded />
                      </IconButton>
                    </Grid>
                  )}
                  {state?.additional?.twitter && (
                    <Grid item md={2}>
                      <IconButton
                        onClick={() => {
                          const url = state.additional.twitter.startsWith('http')
                            ? state.additional.twitter
                            : `https://${state.additional.twitter}`;
                          window.open(url, '_blank');
                        }}
                      >
                        <X />
                      </IconButton>
                    </Grid>
                  )}
                  {state?.additional?.linkedin && (
                    <Grid item md={2}>
                      <IconButton
                        onClick={() => {
                          const url = state.additional.linkedin.startsWith('http')
                            ? state.additional.linkedin
                            : `https://${state.additional.linkedin}`;
                          window.open(url, '_blank');
                        }}
                      >
                        <LinkedIn />
                      </IconButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item md={9}>
                <Grid container justifyContent={"space-between"} sx={{ height: "100%" }}>
                  <Grid item md={12}>
                    <Box sx={{ height: "100%", display: "flex", alignItems: "center", }}>
                      <Box sx={{ p: "20px", display: "flex", flexDirection: "column", gap: "30px" }}>
                        <Box>
                          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
                            User Profile:
                          </Typography>
                        </Box>
                        <Grid container spacing={2} rowSpacing={3}>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Name:</Typography>
                              <Typography variant={"subtitle1"}>{state?.name}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Phone:</Typography>
                              <Typography variant={"subtitle1"}>{state?.phone_Number}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Email:</Typography>
                              <Tooltip title={state?.email} arrow>
                                <Typography
                                  variant={"subtitle1"}
                                  sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}
                                >
                                  {state?.email}
                                </Typography>
                              </Tooltip>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Country:</Typography>
                              <Typography variant={"subtitle1"}>{state?.country ?? "-"}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>City:</Typography>
                              <Typography variant={"subtitle1"}>{state?.city ?? "-"}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>State:</Typography>
                              <Typography variant={"subtitle1"}>{state?.state ?? "-"}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Service:</Typography>
                              <Typography variant={"subtitle1"}>{state?.additional?.services?.name ?? "-"}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Industry:</Typography>
                              <Typography variant={"subtitle1"}>{state?.additional?.industry?.name ?? "-"}</Typography>
                            </Box>
                          </Grid>
                          <Grid item md={4}>
                            <Box sx={{ display: "flex", width: "100%", gap: "10px" }}>
                              <Typography variant={"subtitle1"} sx={{ fontWeight: 600 }}>Current Role:</Typography>
                              <Typography variant={"subtitle1"}>{state?.additional?.currentRole ?? "-"}</Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Box
          sx={{
            mt: "8px"
          }}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Ads" {...a11yProps(0)} />
              <Tab label="Proposals" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <TableContainer
              sx={{
                boxShadow: "0px 0px 10px 2px #e3e3e3",
                mt: "20px",
                borderRadius: "4px",
                backgroundColor: Colors.white
              }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {tableHead.map((item, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {item}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userJobs.map((row, ind) => (
                    <TableRow key={ind}>
                      <TableCell>
                        {row?.title}
                      </TableCell>
                      <TableCell>
                        {row?.category.map((item) => item.name)}
                      </TableCell>
                      <TableCell>
                        {moment(row?.createdAt).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell>
                        {moment(row?.valid_till).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            cursor: "pointer",
                            textDecoration: "underline",
                            color: Colors.purple
                          }}
                          component={"a"}
                          onClick={() => navigate("/proposals", { state: { id: row?._id } })}
                        >
                          {row?.totalProposals}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={row?.isCompleted == true ? "Completed" : row?.isApproved == null ? "Pending" : row?.isApproved == true ? "Approved" : "Disapproved"}
                          sx={{
                            bgcolor: row?.isCompleted == true ? Colors.gunMetal : row?.isApproved == null ? Colors.danger + 26 : row?.isApproved == true ? Colors.success + 26 : Colors.danger + 26,
                            color: row?.isCompleted == true ? Colors.white : row?.isApproved == null ? Colors.danger : row?.isApproved == true ? Colors.success : Colors.danger,
                            height: 26,
                            textTransform: 'capitalize',
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View">
                          <IconButton onClick={() => navigate(`/job-details/${row._id}`, { state: row })}>
                            <RemoveRedEye />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <TableContainer
              sx={{
                boxShadow: "0px 0px 10px 2px #e3e3e3",
                mt: "20px",
                borderRadius: "4px",
                backgroundColor: Colors.white
              }}
              component={Paper}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {tableHead1.map((item, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          fontWeight: "bold",
                        }}
                      >
                        {item}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userProposals.map((row, ind) => (
                    <TableRow key={ind}>
                      <TableCell>
                        {moment(row?.submittedBy?.create_at).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell
                        component={"a"}
                        sx={{
                          textDecoration: "underline",
                          cursor: "pointer",
                          color: Colors.purple
                        }}
                        onClick={() => navigate(`/jobs`, { state: { id: row?.adId?._id } })}
                      >
                        {row?.adId?.title}
                      </TableCell>
                      <TableCell>
                        PKR {row?.budget}
                      </TableCell>
                      <TableCell>
                        {row?.jobDuration}
                      </TableCell>
                      <TableCell>
                        <Chip
                          label={row?.status == false ? "Pending" : "Hired"}
                          sx={{
                            backgroundColor: row?.status == false ? Colors.danger + 26 : Colors.success + 26,
                            color: row?.status == false ? Colors.danger : Colors.success,
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View">
                          <IconButton onClick={() => navigate(`/proposal-details/${row._id}`, { state: row })}>
                            <RemoveRedEye />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Box>
      </Box>
    </Fragment >
  )
}

export default ProviderDetails;